import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useApiContext from 'hooks/useApiContext';
import routes from 'router/routes';
import { iScanInfo } from 'services/Ticketing/Ticketing.type';
import ScannerView, { ScannerApi } from './ScannerView';

/** Scanner of the admins and moderators of an event (EM account). */
export default function Scanner(): JSX.Element {
  const { eventId = '' } = useParams();
  const { ticketingRepository } = useApiContext();
  const navigate = useNavigate();
  const [info, setInfo] = useState<iScanInfo | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    ticketingRepository
      .getScanInfo(eventId)
      .then(setInfo)
      .catch((e: Error) => setLoadError(e.message));
  }, [eventId]);

  const api = useMemo<ScannerApi>(
    () => ({
      storageKey: `em.scan.${eventId}`,
      scan: async (code, device) =>
        await ticketingRepository.scanRequest(eventId, code, device),
      sync: async (scans, device) =>
        await ticketingRepository.syncScans(eventId, scans, device),
      offline: async () => await ticketingRepository.getOfflineList(eventId),
      lookup: async (q) => await ticketingRepository.lookup(eventId, q),
    }),
    [eventId, ticketingRepository]
  );

  if (loadError) return <div style={{ padding: 24 }}>{loadError}</div>;
  if (!info)
    return (
      <div style={{ padding: 24, background: '#030712', minHeight: '100vh' }} />
    );
  return (
    <ScannerView
      api={api}
      title={info.event.name}
      timezone={info.timezone}
      eventDays={info.event.days ?? []}
      initialCounters={info.counters}
      onBack={() => navigate(`${routes.home2.path}scan`)}
    />
  );
}
